import React from 'react';
import { Info, ChevronRight, MapPin, Phone, Mail, Instagram, Facebook } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Qué requisitos necesito para solicitar un crédito?',
    a: 'Solo necesitás ser mayor de 18 años, tener DNI argentino y contar con ingresos demostrables (recibo de sueldo, monotributo o jubilación).'
  }, {
    q: '¿En cuánto tiempo recibo el dinero?',
    a: 'Una vez aprobada tu solicitud, el dinero se transfiere a tu cuenta bancaria (CBU) en el transcurso de 24 horas hábiles.'
  }, {
    q: '¿Puedo cancelar el crédito antes del plazo?',
    a: 'Sí, podés cancelar tu crédito de forma anticipada cuando lo desees, abonando los intereses correspondientes hasta la fecha de cancelación.'
  }, {
    q: '¿Qué pasa si me atraso con una cuota?',
    a: 'En caso de atraso, se aplicarán intereses punitorios diarios. Te recomendamos contactarnos antes del vencimiento si tenés dificultades para pagar.'
  }];
  return <section id="faq" className="py-20 bg-gray-50" data-id="element-158">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-159">
        <div className="flex items-center justify-center gap-3 mb-12" data-id="element-160">
          <Info className="w-8 h-8 text-blue-900" data-id="element-161" />
          <h2 className="text-3xl font-extrabold text-blue-900" data-id="element-162">
            Preguntas Frecuentes
          </h2>
        </div>
        <div className="space-y-4" data-id="element-163">
          {faqs.map((faq, i) => <details key={i} className="group bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-164">
              <summary className="flex justify-between items-center font-bold cursor-pointer list-none p-6 text-gray-900 hover:text-blue-900" data-id="element-165">
                <span data-id="element-166">{faq.q}</span>
                <span className="transition group-open:rotate-180" data-id="element-167">
                  <ChevronRight className="w-5 h-5" data-id="element-168" />
                </span>
              </summary>
              <div className="text-gray-600 px-6 pb-6 pt-0" data-id="element-169">{faq.a}</div>
            </details>)}
        </div>
      </div>
    </section>;
}
export function Footer() {
  return <footer id="contacto" className="bg-gray-900 text-white pt-16 pb-8" data-id="element-170">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-171">
        <div className="grid md:grid-cols-2 gap-12 mb-12" data-id="element-172">
          {/* Brand */}
          <div data-id="element-173">
            <div className="flex items-center gap-3 mb-6" data-id="element-174">
              <img src="https://cdn.magicpatterns.com/uploads/uB3M9w8su6P2THNwnbY3ow/71e2d423-eec7-4cf1-bb5d-7f9fe5f3787f.jpg" alt="Finance Group" className="h-12 w-12 rounded-lg object-cover" data-id="element-175" />
              <span className="font-bold text-2xl tracking-tight text-white" data-id="element-176">
                FINANCE <span className="text-blue-400" data-id="element-177">GROUP</span>
              </span>
            </div>
            <p className="text-gray-400 mb-6 max-w-md" data-id="element-178">
              Tu socio financiero de confianza. Soluciones rápidas,
              transparentes y a tu medida.
            </p>
            <div className="flex gap-4" data-id="element-179">
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-blue-600 transition-colors" data-id="element-180">
                <Instagram className="w-5 h-5" data-id="element-181" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center hover:bg-blue-600 transition-colors" data-id="element-182">
                <Facebook className="w-5 h-5" data-id="element-183" />
              </a>
            </div>
          </div>

          {/* Contact */}
          <div data-id="element-184">
            <h3 className="text-lg font-bold mb-6 text-white" data-id="element-185">Contacto</h3>
            <ul className="space-y-4" data-id="element-186">
              <li className="flex items-start gap-3 text-gray-400" data-id="element-187">
                <Phone className="w-5 h-5 text-blue-400 shrink-0 mt-0.5" data-id="element-188" />
                <span data-id="element-189">+54 9 11 2269-6510</span>
              </li>
              <li className="flex items-start gap-3 text-gray-400" data-id="element-190">
                <Mail className="w-5 h-5 text-blue-400 shrink-0 mt-0.5" data-id="element-191" />
                <span data-id="element-192">contacto@financegroup.com.ar</span>
              </li>
              <li className="flex items-start gap-3 text-gray-400" data-id="element-193">
                <MapPin className="w-5 h-5 text-blue-400 shrink-0 mt-0.5" data-id="element-194" />
                <span data-id="element-195">
                  Av. Corrientes 1234, Piso 5<br data-id="element-196" />
                  CABA, Argentina
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500" data-id="element-197">
          <p data-id="element-198">
            © {new Date().getFullYear()} Finance Group. Todos los derechos
            reservados.
          </p>
          <div className="flex gap-4" data-id="element-199">
            <a href="#" className="hover:text-white transition-colors" data-id="element-200">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-201">
              Políticas de Privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>;
}